const ORDINAL_ONES: Record<number, string> = {
  1: 'First',
  2: 'Second',
  3: 'Third',
  4: 'Fourth',
  5: 'Fifth',
  6: 'Sixth',
  7: 'Seventh',
  8: 'Eighth',
  9: 'Ninth',
}

const ORDINAL_TEENS: Record<number, string> = {
  10: 'Tenth',
  11: 'Eleventh',
  12: 'Twelfth',
  13: 'Thirteenth',
  14: 'Fourteenth',
  15: 'Fifteenth',
  16: 'Sixteenth',
  17: 'Seventeenth',
  18: 'Eighteenth',
  19: 'Nineteenth',
}

const ORDINAL_TENS: Record<number, string> = {
  2: 'Twentieth',
  3: 'Thirtieth',
  4: 'Fortieth',
  5: 'Fiftieth',
  6: 'Sixtieth',
  7: 'Seventieth',
  8: 'Eightieth',
  9: 'Ninetieth',
}

const TENS_PREFIX: Record<number, string> = {
  2: 'Twenty',
  3: 'Thirty',
  4: 'Forty',
  5: 'Fifty',
  6: 'Sixty',
  7: 'Seventy',
  8: 'Eighty',
  9: 'Ninety',
}

function toOrdinalWords (n: number): string | null {
  if (n <= 0 || n > 100) return null
  if (ORDINAL_ONES[n]) return ORDINAL_ONES[n]
  if (ORDINAL_TEENS[n]) return ORDINAL_TEENS[n]

  const tens = Math.floor(n / 10)
  const ones = n % 10

  if (ones === 0) return ORDINAL_TENS[tens]
  return `${TENS_PREFIX[tens]}-${ORDINAL_ONES[ones]}`
}

function toOrdinalSuffix (n: number): string {
  const pr = new Intl.PluralRules('en', { type: 'ordinal' })
  const suffix = pr.select(n)
  const endings: Record<string, string> = {
    one: 'st',
    two: 'nd',
    few: 'rd',
    other: 'th',
  }
  return endings[suffix]
}

export function numberToOrdinalText (n: number): string {
  return toOrdinalWords(n) ?? `${n}${toOrdinalSuffix(n)}`
}
